export const colorBlue = {
    color: '#2196f3'
}

export const formFieldError = {
    color:'#bf2d2d',
};